import Swiper from "swiper";
import SwiperCore, { Navigation, Pagination } from "swiper/core";
import { register } from "@shopify/theme-sections";

register("split_hero_module", {
  onLoad() {
    SwiperCore.use([Navigation, Pagination]);
    var heroCarousel = new Swiper(".swiper-split-hero", {
      loop: true,
      resistance: true,
      resistanceRatio: 0,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".swiper-pagination-hero",
        clickable: true,
      },
    });
    $(".swiper-pagination-hero").delay(50).show(0);
  },
});
